var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _rect5, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#26C9FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0426 111V41.1818H75.2244C80.5881 41.1818 85.0881 42.1818 88.7244 44.1818C92.3835 46.1818 95.1449 48.9318 97.0085 52.4318C98.8949 55.9091 99.8381 59.8636 99.8381 64.2955C99.8381 68.7727 98.8949 72.75 97.0085 76.2273C95.1222 79.7045 92.3381 82.4432 88.6562 84.4432C84.9744 86.4205 80.4403 87.4091 75.054 87.4091H57.7017V77.0114H73.3494C76.4858 77.0114 79.054 76.4659 81.054 75.375C83.054 74.2841 84.5313 72.7841 85.4858 70.875C86.4631 68.9659 86.9517 66.7727 86.9517 64.2955C86.9517 61.8182 86.4631 59.6364 85.4858 57.75C84.5313 55.8636 83.0426 54.3977 81.0199 53.3523C79.0199 52.2841 76.4403 51.75 73.2812 51.75H61.6903V111H49.0426ZM148.767 60.375C148.449 57.3977 147.108 55.0795 144.744 53.4205C142.403 51.7614 139.358 50.9318 135.608 50.9318C132.972 50.9318 130.71 51.3295 128.824 52.125C126.938 52.9205 125.494 54 124.494 55.3636C123.494 56.7273 122.983 58.2841 122.96 60.0341C122.96 61.4886 123.29 62.75 123.949 63.8182C124.631 64.8864 125.551 65.7955 126.71 66.5455C127.869 67.2727 129.153 67.8864 130.562 68.3864C131.972 68.8864 133.392 69.3068 134.824 69.6477L141.369 71.2841C144.006 71.8977 146.54 72.7273 148.972 73.7727C151.426 74.8182 153.619 76.1364 155.551 77.7273C157.506 79.3182 159.051 81.2386 160.188 83.4886C161.324 85.7386 161.892 88.375 161.892 91.3977C161.892 95.4886 160.847 99.0909 158.756 102.205C156.665 105.295 153.642 107.716 149.688 109.466C145.756 111.193 140.994 112.057 135.403 112.057C129.972 112.057 125.256 111.216 121.256 109.534C117.278 107.852 114.165 105.398 111.915 102.17C109.688 98.9432 108.483 95.0114 108.301 90.375H120.744C120.926 92.8068 121.676 94.8295 122.994 96.4432C124.313 98.0568 126.028 99.2614 128.142 100.057C130.278 100.852 132.665 101.25 135.301 101.25C138.051 101.25 140.46 100.841 142.528 100.023C144.619 99.1818 146.256 98.0227 147.438 96.5455C148.619 95.0455 149.222 93.2955 149.244 91.2955C149.222 89.4773 148.688 87.9773 147.642 86.7955C146.597 85.5909 145.131 84.5909 143.244 83.7955C141.381 82.9773 139.199 82.25 136.699 81.6136L128.756 79.5682C123.006 78.0909 118.46 75.8523 115.119 72.8523C111.801 69.8295 110.142 65.8182 110.142 60.8182C110.142 56.7045 111.256 53.1023 113.483 50.0114C115.733 46.9205 118.79 44.5227 122.653 42.8182C126.517 41.0909 130.892 40.2273 135.778 40.2273C140.733 40.2273 145.074 41.0909 148.801 42.8182C152.551 44.5227 155.494 46.8977 157.631 49.9432C159.767 52.9659 160.869 56.4432 160.938 60.375H148.767ZM196.827 111H173.168V41.1818H197.304C204.236 41.1818 210.19 42.5795 215.168 45.375C220.168 48.1477 224.009 52.1364 226.69 57.3409C229.372 62.5455 230.713 68.7727 230.713 76.0227C230.713 83.2955 229.361 89.5455 226.656 94.7727C223.974 100 220.099 104.011 215.031 106.807C209.986 109.602 203.918 111 196.827 111ZM185.815 100.057H196.213C201.077 100.057 205.134 99.1705 208.384 97.3977C211.634 95.6023 214.077 92.9318 215.713 89.3864C217.349 85.8182 218.168 81.3636 218.168 76.0227C218.168 70.6818 217.349 66.25 215.713 62.7273C214.077 59.1818 211.656 56.5341 208.452 54.7841C205.27 53.0114 201.315 52.125 196.588 52.125H185.815V100.057Z",
    fill: "#FAFAFD"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 198,
    width: 242,
    height: 242,
    rx: 12,
    fill: "#061E26",
    stroke: "#26C9FF",
    strokeWidth: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.152 354V284.182H212.334C217.697 284.182 222.197 285.182 225.834 287.182C229.493 289.182 232.254 291.932 234.118 295.432C236.004 298.909 236.947 302.864 236.947 307.295C236.947 311.773 236.004 315.75 234.118 319.227C232.232 322.705 229.447 325.443 225.766 327.443C222.084 329.42 217.55 330.409 212.163 330.409H194.811V320.011H210.459C213.595 320.011 216.163 319.466 218.163 318.375C220.163 317.284 221.641 315.784 222.595 313.875C223.572 311.966 224.061 309.773 224.061 307.295C224.061 304.818 223.572 302.636 222.595 300.75C221.641 298.864 220.152 297.398 218.129 296.352C216.129 295.284 213.55 294.75 210.391 294.75H198.8V354H186.152ZM288.774 315.477L277.524 316.705C277.206 315.568 276.649 314.5 275.854 313.5C275.081 312.5 274.036 311.693 272.717 311.08C271.399 310.466 269.786 310.159 267.876 310.159C265.308 310.159 263.149 310.716 261.399 311.83C259.672 312.943 258.82 314.386 258.842 316.159C258.82 317.682 259.376 318.92 260.513 319.875C261.672 320.83 263.581 321.614 266.24 322.227L275.172 324.136C280.126 325.205 283.808 326.898 286.217 329.216C288.649 331.534 289.876 334.568 289.899 338.318C289.876 341.614 288.911 344.523 287.001 347.045C285.115 349.545 282.49 351.5 279.126 352.909C275.763 354.318 271.899 355.023 267.536 355.023C261.126 355.023 255.967 353.682 252.058 351C248.149 348.295 245.82 344.534 245.07 339.716L257.104 338.557C257.649 340.92 258.808 342.705 260.581 343.909C262.354 345.114 264.661 345.716 267.501 345.716C270.433 345.716 272.786 345.114 274.558 343.909C276.354 342.705 277.251 341.216 277.251 339.443C277.251 337.943 276.672 336.705 275.513 335.727C274.376 334.75 272.604 334 270.195 333.477L261.263 331.602C256.24 330.557 252.524 328.795 250.115 326.318C247.706 323.818 246.513 320.659 246.536 316.841C246.513 313.614 247.388 310.818 249.161 308.455C250.956 306.068 253.445 304.227 256.626 302.932C259.831 301.614 263.524 300.955 267.706 300.955C273.842 300.955 278.672 302.261 282.195 304.875C285.74 307.489 287.933 311.023 288.774 315.477Z",
    fill: "#26C9FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_870",
    x: 37.043,
    y: 40.2266,
    width: 197.672,
    height: 87.832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_870",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsd);
export default __webpack_public_path__ + "static/media/psd.39c0858c57046d2bfab8a5e00054a10b.svg";
export { ForwardRef as ReactComponent };